module.exports = __webpack_public_path__ + "static/media/P2.08b49d75.jpeg";